import React from "react";
import { useWatch } from "react-hook-form";
import SegmentSummaryDialog from "../../../components/SegmentSummaryDialog";
import { useEditSegmentView } from "../EditSegment.context";

function SummaryDialog() {
  const { form, summaryOpen, closeSummary, segmentDetails } =
    useEditSegmentView();

  const filter = useWatch();

  const {
    formState: { isValid },
  } = form;

  return (
    <SegmentSummaryDialog
      open={summaryOpen}
      onClose={closeSummary}
      filter={filter}
      isFilterValid={isValid}
      segmentId={segmentDetails?.id}
    />
  );
}

export default SummaryDialog;
